module.exports = __webpack_public_path__ + "media/test1.1547981d.wav";